
import { Component, Prop } from '@modules/vue-property-decorator';
import { Transport } from '@shared/components/checkout/checkoutPayment.vue';
import { Format } from '@shared/core/helpers/formatHelper';
import Vue from 'vue';

@Component
export default class CheckoutFooter extends Vue {
  @Prop({ required: true }) private submitText!: string;
  @Prop({ default: null }) private error!: string | null;
  @Prop({ default: null }) private transport!: Transport | null;
  @Prop({ default: { promoCode: "", discount: 0, netDiscount: 0, discountedTaxes: 0 } })
  private discountInfo!: { promoCode: string, discount: number, netDiscount: number, discountedTaxes: number };

  private get pricesWithTaxes(): boolean {
    return this.$store.state.settings.PriceWithTaxes === true;
  }

  private get discountToDisplay(): number {
    return this.pricesWithTaxes ? this.discountInfo.discount : this.discountInfo.netDiscount;
  }

  private get subTotal(): number {
    return this.pricesWithTaxes
      ? this.$store.state.cart.total
      : this.$store.state.cart.netTotal;
  }

  private get total() {
    let total = this.$store.state.cart.total - this.discountInfo.discount;
    if (this.transport?.product) {
      total += this.transport.product.grossPrice;
    }
    return total;
  }

  private get cartTaxes() {
    return this.$store.state.cart.total - this.$store.state.cart.netTotal - this.discountInfo.discountedTaxes;
  }

  private formatPrice(price: string | number): string {
    return Format.formatCurrency(price.toString());
  }
}
